import { attr} from 'redux-orm';
import Model from '../base-model';
import attachmentReducers from './attachment.reducer';
import { attachmentActions } from './attachment.action';

/**
 * Attachment
 * @typedef {Object} Attachment
 * @property {string} id
 * @property {string} title
 * @property {string} status
 */

export class Attachment extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case attachmentActions.setStatusUploading:
            attachmentReducers.setStatus(session, action.id, 'uploading');
            break;
        case attachmentActions.setStatusError:
            attachmentReducers.setStatus(session, action.id, 'error');
            break;
        case attachmentActions.setStatusUploaded:
            attachmentReducers.setStatus(session, action.id, 'uploaded');
            break;
        case attachmentActions.setStatusEmpty:
            attachmentReducers.setStatus(session, action.id, 'empty');
            break;
        case attachmentActions.setUploadingProgress:
            attachmentReducers.setUploadingProgress(session, action.id, action.progress);
            break;
        case attachmentActions.cleanUploadingProgress:
            attachmentReducers.setUploadingProgress(session, action.id, 0);
            break;
        case attachmentActions.setFilePath:
            attachmentReducers.setFilePath(session, action.id, action.filePath);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Attachment: ${this.title}`
    }
}

Attachment.modelName = 'Attachment';

Attachment.fields = {
    id: attr(),
    title: attr(),
    status: attr(),
    file: attr(),
    uploadingProgress: attr(),
}